var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminContainer',[_c('div',{staticClass:"wrapper-container"},[_c('div',{staticClass:"container-widget-header"}),_c('div',{staticClass:"body-widget"},[_c('h1',[_vm._v("Welcome here again!!!")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }